module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-26-fda3c31e1923d96ec010f9f5190946d2.jpg";